module.exports = __webpack_public_path__ + "img/signatureEle.21e57a85.svg";